import { CityLedgerFilterValues, FiltersValueKey } from './schema';

export const defaultFilterValues: CityLedgerFilterValues = {
    [FiltersValueKey.searchQuery]: '',
    [FiltersValueKey.ownerTypes]: [],
    [FiltersValueKey.ageing]: [],
};
